
export default {
  name: "PopularRoutes",

  props: {
    routes: {
      type: Array,
      default: () => {
        return []
      }
    },
    isLoad: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    defaultSubdomain: function () {
      return this.$store.state?.appState?.vars?.['Дефолтный SLUG города'] || ""
    },

    message: function () {
      return this.$store.state?.appState?.vars?.['Публичная оферта страниц маршрутов']
    }
  },

  components: {
    AnotationMessage: () => import("~/components/routes/AnotationMessage")
  },

  methods: {
    getUrlRoute: function (route) {
      const defaultSubdomain = this.defaultSubdomain;
      return `/routes/${route?.cities?.from?.sub_domain || this.defaultSubdomain}/${route?.cities?.to?.sub_domain || this.defaultSubdomain}`
    }
  }
}
